import wallpaper from "../../../assets/NURSERY 01.jpg";
// import wallpaper from "../../../assets/homeslug2.jpg";
const HomeSlugDesktop = () => {
    return (
        <div className="home__container container grid">
            <div style={{
                position: "absolute",
            }} >
                <img
                    src={wallpaper}
                    alt="Nursery Wallpaper"
                    style={{
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        zIndex: "-1",
                    }}
                />
            </div>
            <div className="home__data" style={{ padding: "2rem", width: "100%" }}>
                <div style={{ position: "relative", display: "inline-block" }}>
                    <h2
                        className="home__title"
                        style={{
                            fontFamily: "Century Gothic",
                            fontSize: "4.5rem",
                            color: "#5a7547",
                            marginBottom: "1rem",
                        }}
                    >
                        GROWING NATURE
                    </h2>
                    <span
                        style={{
                            fontFamily: "Rustic Roadway",
                            fontSize: "4rem",
                            color: "#ffff",
                            position: "absolute",
                            bottom: "0.7rem",
                            right: "-20px",
                        }}
                    >
                        growing you
                    </span>
                </div>
                <div style={{ position: "relative" }}>
                    <p
                        className="home__description"
                        style={{
                            fontSize: "1.2rem",
                            color: "#5a7547",
                            lineHeight: "1.6",
                            marginTop: "5rem",
                            fontFamily: "Century Gothic",
                            width: "70%"
                        }}
                    >
                        We specialize in providing a diverse range of plants and trees
                        to beautify your surroundings. Whether you're a seasoned
                        gardener or a beginner.
                    </p>
                    <a
                        href="#about"
                        className="button button--flex"
                        style={{
                            display: "inline-flex",
                            alignItems: "center",
                            padding: "0.8rem 1.5rem",
                            backgroundColor: "#e67e22",
                            color: "#ffffff",
                            borderRadius: "5px",
                            textDecoration: "none",
                            fontWeight: "bold",
                            marginTop: "1.5rem",
                            fontFamily: "Century Gothic",
                        }}
                    >
                        EXPLORE
                        <i
                            className="ri-arrow-right-down-line button__icon"
                            style={{ marginLeft: "0.5rem" }}
                        ></i>
                    </a>
                </div>

            </div>
        </div >
    );
};

export default HomeSlugDesktop;
